import * as Yup from 'yup'

export const schemaPayment = (t: (key: string) => string) => ({
  paymentFormOption: Yup.string().required(t('requiredMessage')),
  paymentMethodOption: Yup.string().required(t('requiredMessage')),
})
